<!--
 Description: 实有人口 List
 Author: 作者
 Date:   2021-03-08
-->
<template>
  <a-row :gutter="10">
    <a-col :md="leftColMd" :sm="24" style="margin-bottom: 20px">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input placeholder="请输入姓名" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col> -->
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="账号">
                  <a-input placeholder="请输入账号" v-model="queryParam.username"></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="部门">
                  <div placeholder="请输入部门" class="ant-input" aria-readonly="true" @click="xzzz" >{{orgName}}</div>
                </a-form-item>
              </a-col>

              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource1"
            :pagination="ipagination1"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">

            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>

            <template slot="avatarslot" slot-scope="text, record, index">
              <div class="anty-img-wrap">
                <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
              </div>
            </template>

            <template slot="imgSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
              <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
            </template>
            <template slot="pcaSlot" slot-scope="text">
              <div>{{ getPcaText(text) }}</div>
            </template>
            <template slot="fileSlot" slot-scope="text">
              <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
              <a-button
                v-else
                :ghost="true"
                type="primary"
                icon="download"
                size="small"
                @click="downloadFile(text)">
                下载
              </a-button>
            </template>
            <span slot="rowIndex1" slot-scope="text, record, index">
              {{(ipagination1.current-1)*ipagination1.pageSize+index+1}}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="handleOpen(record)">绑定手机号</a>
            </span>
          </a-table>
        </div>

        <user-phone-bind-left ref="modalForm4" @ok4="modalFormOk4"></user-phone-bind-left>

      </a-card>
  </a-col>
  <!-- 绑定列表 -->
  <a-col :md="rightColMd" :sm="24" v-if="this.rightcolval == 1">
      <a-card :bordered="false">
        <div style="text-align: right;">
          <a-icon type="close-circle" @click="hideUserList" />
        </div>
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          
        </div>
        
        <div class="table-operator">
          <a-button @click="handleAdd2" type="primary" icon="plus">新增绑定</a-button>
        </div>
       
        <div>
          <a-table
            style="height:500px"
            ref="table2"
            bordered
            size="middle"
            rowKey="id"
            :columns="columns2"
            :dataSource="dataSource2"
            :pagination="ipagination2"
            :loading="loading2"
            @change="handleTableChange2">

            <span slot="rowIndex2" slot-scope="text, record, index">
              {{(ipagination2.current-1)*ipagination2.pageSize+index+1}}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit2(record)" >编辑</a>
              <a-divider type="vertical"/>
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete2(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </a-table>
        </div>
        <!-- 表单区域 -->
        <user-phone-bind-modal ref="modalForm2" @ok="modalFormOk2"></user-phone-bind-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Area from '@/components/_util/Area'

  import { deleteAction, postAction, getAction, getFileAccessHttpUrl } from '@/api/manage'
  import orgSelect from '@/components/dict/OrgSelect'
  import UserPhoneBindModal from './modules/UserPhoneBindModal__Style#Drawer'
  import UserPhoneBindLeft from './UserPhoneBindLeft'



  import { filterObj } from '@/utils/util'
  import moment from 'moment'

  export default {
    name: 'PersonList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      UserPhoneBindModal,
      orgSelect,
      UserPhoneBindLeft,
      moment
    },
    data () {
      return {
        description: '实有人口管理页面',
        model1: {},
        model2: {},
        currentRoleId: '',
        queryParam: {username:"",orgCode:""},
        queryParam2: {},
        dataSource1: [],
        dataSource2: [],
        ipagination1: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        ipagination2: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        isorter1: {
          column: 'createTime',
          order: 'desc'
        },
        isorter2: {
          column: 'createTime',
          order: 'desc'
        },
        filters1: {},
        filters2: {},
        loading1: false,
        loading2: false,
        selectedRowKeys1: [],
        selectedRowKeys2: [],
        selectionRows1: [],
        selectionRows2: [],
        test:{},
        rightcolval:0,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            scopedSlots: { customRender: 'rowIndex1' }
          },
          {
            title: '用户账号',
            align: "center",
            dataIndex: 'username',
            width: 120,
            sorter: true
          },
          {
            title: '用户姓名',
            align: "center",
            width: 100,
            dataIndex: 'realname',
          },
          {
            title: '头像',
            align: "center",
            width: 120,
            dataIndex: 'avatar',
            scopedSlots: {customRender: "avatarslot"}
          },

          {
            title: '性别',
            align: "center",
            width: 80,
            dataIndex: 'sex_dictText',
            sorter: true
          },
          {
            title: '生日',
            align: "center",
            width: 100,
            dataIndex: 'birthday'
          },
          {
            title: '手机号码',
            align: "center",
            width: 100,
            dataIndex: 'phone'
          },
          {
            title: '部门',
            align: "center",
            width: 180,
            dataIndex: 'orgCodeTxt'
          },
          {
            title: '状态',
            align: "center",
            width: 80,
            dataIndex: 'status_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 170
          }

        ],
        columns2: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            scopedSlots: { customRender: 'rowIndex2' }
          },
          {
            title:'手机唯一标识码',
            align:"center",
            dataIndex: 'phoneUniqueId'
          },
          {
            title:'手机号码',
            align:"center",
            dataIndex: 'phone'
          },
          {
            title:'用户名',
            align:"center",
            dataIndex: 'username'
          },
          {
            title:'绑定时间',
            align:"center",
            dataIndex: 'bindingTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/user/list/grant",
          list2:"/system/sysusercheck/page",
          delete2: "/system/sysusercheck/delete",          
        },
        dictOptions:{},
        pcaData:'',
        viewRecord:{},
        addType:'',
        orgName:""
      }
    },
    created() {
      this.pcaData = new Area();
      this.loadData(1);
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      leftColMd() {
        return this.selectedRowKeys1.length === 0 ? 24 : 12
      },
      rightColMd() {
        return this.selectedRowKeys1.length === 0 ? 0 : 12
      }
    },
    methods: {
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar)
      },
      getPcaText(code){
        return this.pcaData.getText(code);
      },

      getQueryParams2() {
        //获取查询条件
        let sqp = {}
        if (this.superQueryParams2) {
          sqp['superQueryParams'] = encodeURI(this.superQueryParams2)
          sqp['superQueryMatchType'] = this.superQueryMatchType2
        }
        var param = Object.assign(sqp, this.queryParam2, this.isorter2, this.filters2)

        param.field = "";
        param.pageNo = this.ipagination2.current;
        param.pageSize = this.ipagination2.pageSize;
        return filterObj(param);
      },
      getQueryField2() {
        //TODO 字段权限控制
        var str = 'id,'
        this.columns2.forEach(function(value) {
          str += ',' + value.dataIndex
        })
        return str
      },
      handleEdit2: function(record) {
        this.addType = '02';
        this.$refs.modalForm2.title = '编辑';
        this.$refs.modalForm2.disableSubmit = false;
        this.$refs.modalForm2.edit(record);
      },
      handleAdd2: function() {
        this.addType = '02';
        this.$refs.modalForm2.add(this.viewRecord);
        this.$refs.modalForm2.title = "新增";
        this.$refs.modalForm2.disableSubmit = false;
        
      },
      modalFormOk2() {
        // 新增/修改 成功时，重载列表
        if(this.addType=='01'){
          this.loadData();
        }else if(this.addType=='02'){
          this.loadData2();
        }
        
      },
      loadData(arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list1属性!')
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination1.current = 1
        }
        this.loading = true
        var lett = {
          pageNo:this.ipagination1.current
          ,pageSize:this.ipagination1.pageSize
          ,username:this.queryParam.username
          ,orgCode:this.queryParam.orgCode
          }
          let that = this;
        getAction(this.url.list, lett).then((res) => {
          if (res.success) {
            that.dataSource1 = res.result.records
            that.ipagination1.total = res.result.total;
            that.ipagination1.current = res.result.current;
          }
          that.loading = false
        })

      },

      loadData2(arg) {
        if (!this.url.list2) {
          this.$message.error('请设置url.list2属性!')
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination2.current = 1
        }
        this.loading2 = true
        
        var lett = {
          pageNo:this.ipagination2.current
          ,pageSize:this.ipagination2.pageSize
          ,username:this.viewRecord.username
          }
        getAction(this.url.list2, lett).then((res) => {
          if (res.success) {
            this.dataSource2 = res.result.records
            this.ipagination2.total = res.result.total
          }
          this.loading2 = false
        })

      },
      handleDelete2: function(id) {
        if (!this.url.delete2) {
          this.$message.error('请设置url.delete2属性!')
          return
        }
        var that = this
        deleteAction(that.url.delete2, { id: id }).then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.loadData2()
          } else {
            that.$message.warning(res.message)
          }
        })
      },
      selectOK(data) {
        let params = {}
        params.roleId = this.currentRoleId
        params.userIdList = []
        for (var a = 0; a < data.length; a++) {
          params.userIdList.push(data[a])
        }
        console.log(params)
        postAction(this.url.addUserRole, params).then((res) => {
          if (res.success) {
            this.loadData2()
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      handleOpen(record) {
        this.viewRecord = record;
        this.rightcolval = 1;
        this.selectedRowKeys1 = ["1"];
        this.loadData2();
      },
      handleEdit: function(record) {
        this.addType = '01';
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
        this.$refs.modalForm.edit(record)
      },
      searchQuery() {
        this.loadData(1)
      },
      searchReset(){
        this.queryParam = {};
        this.orgName = "";
        this.loadData()
      },

      handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination1 = pagination;
      this.loadData();
    },

      handleTableChange2(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter2.column = sorter.field
          this.isorter2.order = 'ascend' == sorter.order ? 'asc' : 'desc'
        }
        this.ipagination2 = pagination
        this.loadData2()
      },
      hideUserList(){
        //this.rightcolval = 0
        this.selectedRowKeys1 = []
      },
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title="详情";
        this.$refs.modalForm.disableSubmit = true;
      },
      handleDetail2:function(record){
        this.$refs.modalForm2.edit(record);
        this.$refs.modalForm2.title="详情";
        this.$refs.modalForm2.disableSubmit = true;
      },
      xzzz:function(e){
        this.$refs.modalForm4.visible=true;
        this.$refs.modalForm4.queryTreeData();
        this.$refs.modalForm4.title="行政组织";
        this.$refs.modalForm4.disableSubmit = true;
      },
      modalFormOk4(obj){
        var departName = obj.departName;
        var orgCode = obj.orgCode;
        this.queryParam.orgCode = orgCode;
        this.orgName = departName;
      }
    }
  }
  
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>